export default __webpack_public_path__ + "static/media/roti-roesli-im-garte.14bd06ce.png";